/* ============================================
   AKKI-CHAN Custom JS
   Intro overlay, scroll reveal, header scroll
============================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* --- Intro Overlay（TOP初回アクセス時のみ表示） --- */
  var intro = document.getElementById('akki-intro');
  var introSeenKey = 'akki-intro-seen-v1';

  function hasSeenIntro() {
    try {
      return window.localStorage.getItem(introSeenKey) === 'true';
    } catch (e) {
      return false;
    }
  }

  function setIntroSeen() {
    try {
      window.localStorage.setItem(introSeenKey, 'true');
    } catch (e) {
      // localStorageが使用できない環境では何もしない
    }
  }

  if (intro) {
    if (hasSeenIntro()) {
      /* 2回目以降：即非表示 */
      intro.classList.add('is-hidden');
      intro.style.display = 'none';
    } else {
      /* 初回のみ：アニメーション表示 */
      setIntroSeen();

      setTimeout(function () {
        intro.classList.add('is-hidden');

        setTimeout(function () {
          intro.style.display = 'none';
        }, 800);
      }, 1500);
    }
  }

  /* --- Header scroll state --- */
  var header = document.getElementById('akki-header');
  if (header) {
    function updateHeader() {
      if (window.scrollY > 60) {
        header.classList.add('akki-header--solid');
        header.classList.remove('akki-header--transparent');
      } else {
        header.classList.add('akki-header--transparent');
        header.classList.remove('akki-header--solid');
      }
    }

    window.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader();
  }

  /* --- Mobile Menu Toggle --- */
  var menuBtn = document.getElementById('akki-menu-btn');
  var mobileMenu = document.getElementById('akki-mobile-menu');
  var menuClose = document.getElementById('akki-menu-close');

  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', function () {
      var isOpen = mobileMenu.classList.toggle('is-open');
      menuBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  if (menuClose && mobileMenu) {
    menuClose.addEventListener('click', function () {
      mobileMenu.classList.remove('is-open');

      if (menuBtn) {
        menuBtn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* Close mobile menu on link click */
  if (mobileMenu) {
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileMenu.classList.remove('is-open');

        if (menuBtn) {
          menuBtn.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  /* --- Scroll Reveal --- */
  var reveals = document.querySelectorAll('.akki-reveal');

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });

    reveals.forEach(function (el) {
      observer.observe(el);
    });
  } else {
    reveals.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  /* --- Add to Cart feedback --- */
  document.querySelectorAll('.akki-card__btn[data-product-url]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var variantId = btn.getAttribute('data-variant-id');

      if (!variantId) return;

      e.preventDefault();

      btn.textContent = 'Adding...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
        .then(function (res) {
          return res.json();
        })
        .then(function () {
          btn.textContent = 'Added!';

          setTimeout(function () {
            btn.textContent = 'Add to Cart';
            btn.disabled = false;
          }, 2000);

          fetch('/cart.js')
            .then(function (r) {
              return r.json();
            })
            .then(function (cart) {
              var countEl = document.getElementById('akki-cart-count');

              if (countEl) {
                countEl.textContent = cart.item_count;
                countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
              }
            });
        })
        .catch(function () {
          btn.textContent = 'Add to Cart';
          btn.disabled = false;
        });
    });
  });

});